/**
 * Route definitions. Entry point to all routes.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router';

import ArticleRoute from './article-route';
import { NotFound } from './status-code';

// Match the following:
//  1. Legacy URLs (/articles/{slug}) - these are redirected downstream.
//  2. URLs with variable-length path (/articles/{vertical}/{topic}/*/{slug}).
export const ARTICLE_ROUTE_PATH = '/:verticalPath*/:slug';

// eslint-disable-next-line
export default class AppRoutes extends Component {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
  render() {
    const currentMatchPath = this.props?.match?.path;

    return (
      <Switch>
        <Route
          exact
          path={`${currentMatchPath}${ARTICLE_ROUTE_PATH}`}
          component={ArticleRoute}
        />
        <Route path="*" component={NotFound} />
      </Switch>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AppRoutes.propTypes = {
  match: PropTypes.shape({
    match: PropTypes.string,
  }),
};
